
(function(){
"use strict";
/* ── Textes traduisibles : remplis par Liquid (locales/*.json > ldi18n.js_lpage) ── */
var LDLOC = 'fr-FR';
var LDT = {
  k1: "Récapitulatif de commande",
  k2: "Panier",
  k3: "Fermer",
  k4: "Réduction",
  k5: "Offre d’été",
  k6: "Passer au paiement",
  k7: "Un instant…",
  k8: "Panier • {n} articles",
  k9: "Panier • {n} article",
  k10: "Votre panier est vide.",
  k11: "Retirer un",
  k12: "Ajouter un",
  k13: "Offertes",
  k14: "Offert",
  k15: "Retirer",
  k16: "\u003cb\u003eLivraison offerte débloquée\u003c\/b\u003e",
  k17: "Plus que \u003cb\u003e{prix}\u003c\/b\u003e pour la livraison offerte",
  k18: "Taies offertes",
  k19: "Livraison offerte",
  k20: "Vous économisez {prix} sur ce panier"
};
function ldf(s,o){ return String(s).replace(/\{(\w+)\}/g,function(m,k){ return Object.prototype.hasOwnProperty.call(o,k)?String(o[k]):m; }); }
if (window.LDCart) return;              /* déjà chargé ailleurs : on ne double pas */

var DATA={options:[],variants:[]};
try{ DATA=JSON.parse(document.getElementById('ldx-cart-data').textContent); }catch(e){}

/* ══════════════ CONFIG ══════════════ */
var TAIES = {
  "blanc":      { id:59086977433931, dot:"#FFFFFF"},
  "beige":      { id:59086977466699, dot:"#E0D2BC"},
  "gris":       { id:59086977630539, dot:"#A6A6AC"},
  "noir":       { id:59086977499467, dot:"#2B2B2E"},
  "marron":     { id:59086977597771, dot:"#6D5140"},
  "bleu clair": { id:59086977565003, dot:"#A9C4DA"},
  "bleu nuit":  { id:59086977696075, dot:"#2E3F5E"},
  "rouge":      { id:59086977532235, dot:"#A03A34"}
};
/* Autres façons d'écrire une couleur. À gauche : le nom tel qu'il apparaît
   dans les variantes (sans accent, en minuscules). À droite : la clé de TAIES. */
var ALIAS = {
  "bleu":"bleu clair", "bleu claire":"bleu clair", "bleu ciel":"bleu clair", "bleu pale":"bleu clair",
  "bleu fonce":"bleu nuit", "bleu foncee":"bleu nuit", "bleu marine":"bleu nuit", "marine":"bleu nuit", "navy":"bleu nuit",
  "blanc casse":"blanc", "ecru":"beige", "sable":"beige",
  "anthracite":"gris", "gris clair":"gris", "gris fonce":"gris",
  "taupe":"marron", "chocolat":"marron", "terracotta":"rouge", "bordeaux":"rouge"
};
var EXCLUES = ["vert","green","sauge","olive","kaki"];
var COUETTE_IMG = {
  "blanc":      "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/blanc.png?v=1786385862",
  "beige":      "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/beige.webp?v=1786385711",
  "gris":       "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/gris.webp?v=1786385711",
  "noir":       "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/noir.webp?v=1786385711",
  "marron":     "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/marron.png?v=1786385863",
  "bleu clair": "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/bleu.webp?v=1786385711",
  "bleu nuit":  "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/bleu_fonce.png?v=1786385848",
  "rouge":      "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/rouge.webp?v=1786385710",
  "vert":       "https://cdn.shopify.com/s/files/1/1054/3140/0773/files/vert.webp?v=1786385711"
};
var VALEUR_LOT = 4990;   /* valeur barrée d'un LOT DE 2 taies d'oreiller, en centimes */

/* remise = euros retirés du total du pack. Les prix par taille viennent des
   variantes Shopify, donc le pack suit automatiquement la taille choisie.
   pack   = préfixe affiché dans la pastille d'économie. */
/* Barème de remise, en euros retirés de la COMMANDE (pas du prix unitaire).
   Doit correspondre EXACTEMENT aux réductions automatiques Shopify. */
var REMISES = { 1:0, 2:30, 3:60, 4:80, 5:100, 6:120 };   /* 25/10 journée : remise réelle du paiement (30 €) ; passe à 20 € à minuit avec les nouveaux prix (modifier_minuit.py) */
var REMISE_MAX_QTE = 6;   /* au-delà, on reste sur la remise de 6 */
function remisePour(n){
  if(n>=REMISE_MAX_QTE) return REMISES[REMISE_MAX_QTE];
  return REMISES[n]||0;
}

var SEUIL_LIVRAISON = 10000;   /* 25/10 : livraison offerte dès 100 €, en centimes */
/* ══════════════ FIN CONFIG ══════════════ */

var CUR=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
function fmt(c){ try{ return new Intl.NumberFormat(LDLOC,{style:'currency',currency:CUR}).format(c/100); }
  catch(e){ return (c/100).toFixed(2).replace('.',',')+' €'; } }
function norm(s){ return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(m){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }

/* index des variantes couette */
var ci=-1;
(DATA.options||[]).forEach(function(o,k){ var n=norm(o); if(ci<0&&["couleur","colore","colori","color","colour","farbe"].some(function(w){ return n.indexOf(w)!==-1; })) ci=k; });
if(ci<0&&(DATA.options||[]).length>1) ci=0;   /* à défaut : Couleur = 1re option */
/* couleur traduite -> clé française (Bianco, Blanco, White, Weiß -> blanc) */
var LDREV={"bianco":"blanc","blanco":"blanc","white":"blanc","weiss":"blanc","weiß":"blanc","nero":"noir","negro":"noir","black":"noir","schwarz":"noir","rosso":"rouge","rojo":"rouge","red":"rouge","rot":"rouge","azzurro":"bleu claire","azul claro":"bleu claire","light blue":"bleu claire","hellblau":"bleu claire","marrone":"marron","brown":"marron","braun":"marron","grigio":"gris","grey":"gris","gray":"gris","grau":"gris","verde":"vert","green":"vert","grun":"vert","blu scuro":"bleu fonce","azul oscuro":"bleu fonce","dark blue":"bleu fonce","dunkelblau":"bleu fonce"};
function cfr(s){ var k=norm(s); return LDREV[k]||k; }
var CMP={}, CV_IMG={}, TAIE_IDS={};
Object.keys(TAIES).forEach(function(k){ TAIE_IDS[String(TAIES[k].id)]=1; });
(DATA.variants||[]).forEach(function(v){
  if(v.compare) CMP[String(v.id)]=v.compare;
  if(ci>=0){
    var k=cfr(v.options[ci]);
    var im=COUETTE_IMG[k]||COUETTE_IMG[ALIAS[k]];
    if(im) CV_IMG[String(v.id)]=im;
  }
});

/* ══════════ RÉCAPITULATIF ══════════ */
var DW=null;
function buildDrawer(){
  if(DW) return DW;
  var d=document.createElement('div'); d.className='cfb-dw'; d.hidden=true;
  d.innerHTML='<div class="cfb-dw-ov" data-close></div>'+
    '<aside class="cfb-dw-p" role="dialog" aria-modal="true" aria-label="'+esc(LDT.k1)+'">'+
      '<header class="cfb-dw-h"><span class="cfb-dw-ok" data-cart-title>'+LDT.k2+'</span>'+
        '<button type="button" class="cfb-dw-x" data-close aria-label="'+esc(LDT.k3)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></header>'+
      '<div class="cfb-dw-prog" data-prog></div>'+
      '<div class="cfb-dw-b" data-lines></div>'+
      '<footer class="cfb-dw-f">'+
        '<div class="cfb-dw-tr" data-terms>'+
          '<div class="cfb-dw-tr-l"><span>'+LDT.k4+'</span>'+
            '<em class="cfb-dw-badge">'+
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
              '<path d="M20.6 13.4 12.4 21.6a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1-.6-1.4V4a2 2 0 0 1 2-2h9a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8z"/>'+
              '<circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>'+
              LDT.k5+'</em>'+
            '<b data-red></b></div>'+
        '</div>'+
        '<button type="button" class="cfb-dw-go" data-checkout>'+
          '<svg class="cfb-dw-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
            '<rect x="4" y="10.5" width="16" height="11" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>'+
          '<span>'+LDT.k6+'</span><i class="cfb-dw-go-sep"></i>'+
          '<b data-co-tot></b><s data-co-bar></s>'+
        '</button>'+
        '<p class="cfb-dw-save" data-save></p>'+
      '</footer></aside>';
  document.body.appendChild(d);
  d.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click',closeDrawer); });
  d.querySelector('[data-checkout]').addEventListener('click',function(){
    this.disabled=true; this.textContent=LDT.k7;
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    if(r.charAt(r.length-1)!=='/') r+='/'; window.location.href=r+'checkout'; });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&DW&&!DW.hidden) closeDrawer(); });
  DW=d; return d;
}
function closeDrawer(){ if(DW){ DW.hidden=true; document.documentElement.style.overflow=''; } }

function renderCart(cart){
  var d=buildDrawer(), lines=d.querySelector('[data-lines]');

  var ttl=d.querySelector('[data-cart-title]');
  var nb=(typeof cart.item_count==='number')?cart.item_count
        :(cart.items||[]).reduce(function(a,it){ return a+it.quantity; },0);
  if(ttl) ttl.textContent=ldf(nb>1?LDT.k8:LDT.k9,{n:nb});

  lines.innerHTML='';
  if(!cart.items||!cart.items.length){
    lines.innerHTML='<p class="cfb-dw-empty">'+LDT.k10+'</p>';
    d.querySelector('[data-prog]').innerHTML='';
    d.querySelector('[data-terms]').style.display='none';
    d.querySelector('[data-red]').textContent='';
    d.querySelector('[data-save]').textContent='';
    d.querySelector('[data-co-tot]').textContent='';
    d.querySelector('[data-co-bar]').textContent='';
  } else {
    var sous=0;
    cart.items.forEach(function(it){
      var row=document.createElement('div'); row.className='cfb-dw-l';
      var vid=String(it.variant_id||it.id), strike=0;
      var src=CV_IMG[vid]||it.image||'';   /* couette : photo de sa couleur · taies : photo Shopify */
      var img=src?src.replace(/(\.[a-z]+)(\?|$)/i,'_240x240_crop_center$1$2'):'';
      if(TAIE_IDS[vid]) strike=Math.round(VALEUR_LOT/2)*it.quantity;
      else if(CMP[vid]&&CMP[vid]>it.price) strike=CMP[vid]*it.quantity;
      else if(it.original_line_price>it.line_price) strike=it.original_line_price;
      var free=(it.line_price===0);
      if(!free) sous += (strike>it.line_price? strike : it.line_price);
      row.innerHTML=(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'<span class="cfb-dw-ph"></span>')+
        '<div class="cfb-dw-i"><p class="cfb-dw-n">'+esc(it.product_title)+'</p>'+
          (it.variant_title?'<p class="cfb-dw-v">'+esc(it.variant_title)+'</p>':'')+
          '<div class="cfb-dw-qty"><button type="button" data-dec aria-label="'+esc(LDT.k11)+'">\u2212</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" data-inc aria-label="'+esc(LDT.k12)+'">+</button></div></div>'+
        '<div class="cfb-dw-pr">'+
          (strike>it.line_price?'<s>'+fmt(strike)+'</s>':'')+
          (free?'<b class="cfb-dw-free">'+(TAIE_IDS[vid]?LDT.k13:LDT.k14)+'</b>':'<b>'+fmt(it.line_price)+'</b>')+
        '</div>'+
        '<button type="button" class="cfb-dw-del" aria-label="'+esc(LDT.k15)+'">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
      function setQty(q,btn){
        if(btn){ btn.disabled=true; }
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:it.key,quantity:q})}).then(function(r){return r.json();})
          .then(renderCart).catch(function(){ if(btn) btn.disabled=false; });
      }
      row.querySelector('.cfb-dw-del').addEventListener('click',function(){ setQty(0,this); });
      row.querySelector('[data-inc]').addEventListener('click',function(){ setQty(it.quantity+1,this); });
      var dec=row.querySelector('[data-dec]');
      if(it.quantity<=1) dec.disabled=true;
      dec.addEventListener('click',function(){ setQty(it.quantity-1,this); });
      lines.appendChild(row);
    });
    /* barre : cadeau débloqué + livraison offerte au-delà du seuil */
    var red=Math.max(0,sous-cart.total_price);
    var tp=cart.total_price||0, reste=Math.max(0,SEUIL_LIVRAISON-tp);
    var okShip=(reste<=0), okGift=cart.items.some(function(x){ return x.line_price===0; });
    d.querySelector('[data-prog]').innerHTML=
      '<p class="cfb-dw-pmsg">'+(okShip
        ? '\uD83C\uDF89 '+LDT.k16
        : ldf(LDT.k17,{prix:fmt(reste)}))+'</p>'+
      '<div class="cfb-dw-track"><span class="cfb-dw-fill'+(okShip?' done':'')+'" style="width:'+
        Math.round(Math.min(1,tp/SEUIL_LIVRAISON)*100)+'%"></span>'+
        '<i class="cfb-dw-mk'+(okGift?' on':'')+'" style="left:50%">\uD83C\uDF81</i>'+
        '<i class="cfb-dw-mk'+(okShip?' on':'')+'" style="left:100%">\uD83D\uDE9A</i></div>'+
      '<div class="cfb-dw-mlab"><span class="mid'+(okGift?' on':'')+'">'+LDT.k18+'</span>'+
        '<span class="end'+(okShip?' on':'')+'">'+LDT.k19+'</span></div>';

    var terms=d.querySelector('[data-terms]');
    terms.style.display=red>0?'':'none';
    d.querySelector('[data-red]').textContent=red>0?'\u2212 '+fmt(red):'';

    d.querySelector('[data-co-tot]').textContent=fmt(cart.total_price);
    d.querySelector('[data-co-bar]').textContent=(sous>cart.total_price)?fmt(sous):'';

    d.querySelector('[data-save]').textContent=
      red>0 ? ldf(LDT.k20,{prix:fmt(red)}) : '';
  }
  d.hidden=false; document.documentElement.style.overflow='hidden';
}


/* ══════════ ON REMPLACE LE TIROIR DU THÈME ══════════ */

function ouvrirNotre(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart)
    .catch(function(){ window.location.href='/cart'; });
}

/* 1. Le tiroir natif ne s'affiche jamais */
(function(){
  var st=document.createElement('style');
  st.textContent='cart-drawer,#CartDrawer,#CartDrawer-Overlay{display:none!important;visibility:hidden!important;pointer-events:none!important}';
  document.head.appendChild(st);
})();

/* 2. On surveille le tiroir natif : dès qu'il tente de s'ouvrir, on ouvre le nôtre.
      Ça marche quel que soit le déclencheur : clic, ajout au panier, script du thème. */
(function(){
  function surveiller(){
    var cd=document.querySelector('cart-drawer');
    if(!cd || cd.__ldObs) return;
    cd.__ldObs=true;
    new MutationObserver(function(){
      if(cd.classList.contains('active')){
        cd.classList.remove('active','animate');
        document.body.classList.remove('overflow-hidden');
        if(!DW || DW.hidden) ouvrirNotre();
      }
    }).observe(cd,{attributes:true,attributeFilter:['class']});
  }
  surveiller();
  document.addEventListener('DOMContentLoaded',surveiller);
  window.addEventListener('load',surveiller);
  var n=0, t=setInterval(function(){ surveiller(); if(++n>40) clearInterval(t); },250);
})();

/* 3. On remplace la méthode open() du composant du thème */
(function(){
  function patch(){
    var CD=window.customElements&&customElements.get('cart-drawer');
    if(!CD||CD.prototype.__ld) return true;
    CD.prototype.__ld=true;
    CD.prototype.open=function(){
      this.classList.remove('active','animate');
      document.body.classList.remove('overflow-hidden');
      ouvrirNotre();
    };
    CD.prototype.close=function(){
      this.classList.remove('active','animate');
      document.body.classList.remove('overflow-hidden');
    };
    return true;
  }
  if(!patch()){
    var n=0, t=setInterval(function(){ if(patch()||++n>40) clearInterval(t); },250);
  }
})();

/* 4. On retire les écouteurs du thème posés sur l'icône panier, puis on met le nôtre */
(function(){
  function reprendre(){
    var ic=document.getElementById('cart-icon-bubble');
    if(!ic || ic.__ld) return;
    var neuf=ic.cloneNode(true);        /* le clone n'a plus aucun écouteur */
    neuf.__ld=true;
    ic.parentNode.replaceChild(neuf,ic);
    neuf.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation(); ouvrirNotre();
    });
  }
  reprendre();
  document.addEventListener('DOMContentLoaded',reprendre);
  window.addEventListener('load',reprendre);
  var n=0, t=setInterval(function(){ reprendre(); if(++n>40) clearInterval(t); },250);
})();

/* 5. Filet de sécurité : tout lien vers /cart */
document.addEventListener('click',function(e){
  if(DW&&DW.contains(e.target)) return;
  var n=e.target, ok=false;
  while(n&&n!==document){
    if(n.id==='cart-icon-bubble'){ ok=true; break; }
    var h=n.getAttribute&&n.getAttribute('href');
    if(h&&/\/cart\/?$/.test(h.split('?')[0].split('#')[0])){ ok=true; break; }
    var ac=n.getAttribute&&n.getAttribute('aria-controls');
    if(ac&&ac.toLowerCase().indexOf('cart')!==-1){ ok=true; break; }
    n=n.parentNode;
  }
  if(!ok) return;
  e.preventDefault(); e.stopPropagation(); ouvrirNotre();
},true);

/* API : window.LDCart.open() ouvre le tiroir depuis n'importe où */
window.LDCart = {
  open: function(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart)
      .catch(function(){ window.location.href='/cart'; });
  },
  render: renderCart,
  close: closeDrawer
};
})();
